export const LoginMethod = {
    Email: 'Email',
    Phone: 'Phone',
    Google: 'Google',
    Facebook: 'Facebook',
}